// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Container-module-container-2fhjm{padding-inline:6%;width:100%;max-width:calc(1260px + 12%);margin-inline:auto}.Container-module-container-2fhjm .Container-module-container-2fhjm{padding-inline:0;max-width:100%}", ""]);
// Exports
exports.locals = {
	"container": "Container-module-container-2fhjm"
};
module.exports = exports;
